// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-policy {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}
.privacy-policy h1,
.privacy-policy h2 {
  color: #8e2d8e;
  margin-bottom: 10px;
}
.privacy-policy h1 {
  font-size: 28px;
  text-align: center;
  margin-bottom: 20px;
}
.privacy-policy h2 {
  font-size: 20px;
  margin-top: 20px;
}
.privacy-policy p {
  margin-bottom: 15px;
}
.privacy-policy p.sponsored {
  font-weight: bold;
  color: #d9534f;
}
.privacy-policy ul {
  margin-bottom: 20px;
  padding-left: 20px;
}
.privacy-policy ul li {
  list-style: disc;
  margin-bottom: 10px;
}
.privacy-policy a {
  color: #007bff;
  text-decoration: none;
}
.privacy-policy a:hover {
  text-decoration: underline;
}
@media screen and (max-width: 768px) {
  .privacy-policy {
    padding: 15px;
  }
  .privacy-policy h1 {
    font-size: 24px;
  }
  .privacy-policy h2 {
    font-size: 18px;
  }
  .privacy-policy p {
    font-size: 14px;
  }
  .privacy-policy ul {
    padding-left: 15px;
  }
  .privacy-policy ul li {
    font-size: 14px;
  }
}
@media screen and (max-width: 480px) {
  .privacy-policy {
    padding: 10px;
  }
  .privacy-policy h1 {
    font-size: 20px;
  }
  .privacy-policy h2 {
    font-size: 16px;
  }
  .privacy-policy p {
    font-size: 12px;
  }
  .privacy-policy ul {
    padding-left: 10px;
  }
  .privacy-policy ul li {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/privacy-policy/privacyPolicy.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;AACF;AACE;;EAEE,cAAA;EACA,mBAAA;AACJ;AAEE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;AADJ;AAIE;EACE,mBAAA;AAFJ;AAII;EACE,iBAAA;EACA,cAAA;AAFN;AAME;EACE,mBAAA;EACA,kBAAA;AAJJ;AAMI;EACE,gBAAA;EACA,mBAAA;AAJN;AAQE;EACE,cAAA;EACA,qBAAA;AANJ;AAQI;EACE,0BAAA;AANN;AAWE;EAtDF;IAuDI,aAAA;EARF;EAUE;IACE,eAAA;EARJ;EAWE;IACE,eAAA;EATJ;EAYE;IACE,eAAA;EAVJ;EAaE;IACE,kBAAA;EAXJ;EAaI;IACE,eAAA;EAXN;AACF;AAeE;EA9EF;IA+EI,aAAA;EAZF;EAcE;IACE,eAAA;EAZJ;EAeE;IACE,eAAA;EAbJ;EAgBE;IACE,eAAA;EAdJ;EAiBE;IACE,kBAAA;EAfJ;EAiBI;IACE,eAAA;EAfN;AACF","sourcesContent":[".privacy-policy {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: Arial, sans-serif;\n  line-height: 1.6;\n  color: #333;\n\n  h1,\n  h2 {\n    color: #8e2d8e;\n    margin-bottom: 10px;\n  }\n\n  h1 {\n    font-size: 28px;\n    text-align: center;\n    margin-bottom: 20px;\n  }\n\n  h2 {\n    font-size: 20px;\n    margin-top: 20px;\n  }\n\n  p {\n    margin-bottom: 15px;\n\n    &.sponsored {\n      font-weight: bold;\n      color: #d9534f;\n    }\n  }\n\n  ul {\n    margin-bottom: 20px;\n    padding-left: 20px;\n\n    li {\n      list-style: disc;\n      margin-bottom: 10px;\n    }\n  }\n\n  a {\n    color: #007bff;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  // Responsive design\n  @media screen and (max-width: 768px) {\n    padding: 15px;\n\n    h1 {\n      font-size: 24px;\n    }\n\n    h2 {\n      font-size: 18px;\n    }\n\n    p {\n      font-size: 14px;\n    }\n\n    ul {\n      padding-left: 15px;\n\n      li {\n        font-size: 14px;\n      }\n    }\n  }\n\n  @media screen and (max-width: 480px) {\n    padding: 10px;\n\n    h1 {\n      font-size: 20px;\n    }\n\n    h2 {\n      font-size: 16px;\n    }\n\n    p {\n      font-size: 12px;\n    }\n\n    ul {\n      padding-left: 10px;\n\n      li {\n        font-size: 12px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
